import { IMAGE_MODES } from 'consts/scanSummaryConsts'
import { drawBackgroundWithLayers } from 'utils/canvasUtils'
import { downloadMedia, loadImage } from 'utils/mediaUtils'

export const composePreventivePoses = async ({
  parsedScanSummaryData = {},
  parsedPreventiveImages = {},
  displayedPreventiveLayers = [],
  selectedPoses = [],
  baseImagesMode = IMAGE_MODES.normal
}) => {
  const results = {}

  if (!displayedPreventiveLayers.length) return results

  for (const pose of selectedPoses) {
    try {
      const bgS3 =
        parsedScanSummaryData?.[baseImagesMode]?.[pose] || parsedScanSummaryData?.[IMAGE_MODES.normal]?.[pose]

      if (!bgS3) continue

      const backgroundImageData = await downloadMedia(bgS3)
      const backgroundImage = await loadImage(backgroundImageData)

      const layerS3Objects = displayedPreventiveLayers
        .map(layer => parsedPreventiveImages?.[pose]?.[layer])
        .filter(Boolean)

      const layerImagesData = await Promise.all(layerS3Objects.map(s3 => downloadMedia(s3)))
      const layersImages = await Promise.all(layerImagesData.map(data => loadImage(data)))

      const canvas = document.createElement('canvas')
      canvas.width = backgroundImage.width
      canvas.height = backgroundImage.height

      await drawBackgroundWithLayers({ canvas, backgroundImage, layersImages })

      results[pose] = canvas.toDataURL('image/jpeg', 0.92)
    } catch (e) {
      // skip failed pose composition
    }
  }

  return results
}
